import { vars } from "@imwebme/clay-token";
import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import { Clay } from "..";

export const ModalBody = forwardRef((props: PropsWithChildren, ref: Ref<HTMLDivElement>) => {
  return (
    <Clay ref={ref} padding={vars.spacing[6]} flex={1}>
      {props.children}
    </Clay>
  );
});

ModalBody.displayName = "ModalBody";
